<template>
    <div>
        <Language :add="add" v-model="form.lang" @change="handleLangChange"></Language>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="链接名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入链接名称" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="seo关键词" prop="keyword">
                <DynamicTag v-model="keyword" @change="handleTagChange"></DynamicTag>
            </el-form-item>
            <el-form-item label="链接地址" prop="url">
                <el-input v-model="form.url" placeholder="请输入链接地址" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input v-model="form.sort" placeholder="请输入排序" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button style="width: 120px" type="primary" @click="handleConfirm">确定</el-button>
                <el-button style="width: 120px" @click="$router.back()">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Language from "@/components/Language";
import DynamicTag from "@/components/DynamicTag";
import { add, edit, detail } from "@/api/content/link";
import { getUuid } from "@/jslibs/utils";
export default {
    components: { Language, DynamicTag },
    data() {
        return {
            form: {
                keyword: "",
                lang: "zh",
            },
            rules: {},
            isEdit: false,
            keyword: [],
            cuuid: "",
            add: true,
        };
    },
    mounted() {
        this.form.cuuid = this.$route.query.cuuid;
        if (this.form.cuuid) {
            this.add = false;
            this.isEdit = true;
            this.getDetail();
        } else {
            this.add = true;
            this.form.cuuid = getUuid();
        }
    },
    methods: {
        handleLangChange() {
            this.getDetail();
        },
        getDetail() {
            detail({ cuuid: this.form.cuuid, lang: this.form.lang }).then(({ code, result, error }) => {
                if (code === 200) {
                    if (result) {
                        this.form = { ...result };
                        this.cuuid = result.cuuid;
                        this.form.keyword = result.keyword ? result.keyword.split(",") : [];
                        this.keyword = this.form.keyword;
                    } else {
                        this.form = { lang: this.form.lang, cuuid: this.form.cuuid, keyword: [] };
                        this.keyword = [];
                        this.cuuid = "";
                        this.$nextTick(() => {
                            this.$refs.form.clearValidate();
                        });
                    }
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleTagChange(value) {
            if (value && value.length > 0) {
                this.form.keyword = value;
            } else {
                this.form.keyword = "";
            }
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    ...this.form,
                    keyword: this.form.keyword ? this.form.keyword.join() : "",
                };
                if (this.isEdit) {
                    if (this.cuuid) {
                        edit(params).then(({ code, error }) => {
                            if (code === 200) {
                                this.$message.success("修改成功");
                                this.$router.back();
                            } else {
                                this.$message.error(error.message);
                            }
                        });
                    } else {
                        add(params).then(({ code, error }) => {
                            if (code === 200) {
                                this.$message.success("添加成功");
                                this.$router.back();
                            } else {
                                this.$message.error(error.message);
                            }
                        });
                    }
                } else {
                    add(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("添加成功");
                            this.$router.back();
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                }
            });
        },
    },
};
</script>

<style></style>
